import { TransactionApiTagTypes } from "@/modules/transaction/common/enum";
import { transactionApi } from "@/modules/transaction/services";
import { useAppDispatch } from "@/shared/hooks";
import type { Dispatch, SetStateAction } from "react";

import { DeleteTransactionModal } from "./DeleteTransactionModal";
import { SendToEditModal } from "./SendToEditModal";

interface Props {
  onClose?: () => void;
  isOpenSendToEdit: boolean;
  isDeleteModalOpen: boolean;
  transactionId?: string;
  transactionType?: string;
  setIsOpenSendToEdit: Dispatch<SetStateAction<boolean>>;
  setIsDeleteModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const TransactionActionModals = ({
  onClose = () => {},
  isOpenSendToEdit,
  setIsOpenSendToEdit,
  isDeleteModalOpen,
  setIsDeleteModalOpen,
}: Props) => {
  const dispatch = useAppDispatch();
  const refetch = () => {
    dispatch(transactionApi.util.invalidateTags([TransactionApiTagTypes.TransactionHistory]));
    onClose();
  };

  return (
    <>
      <SendToEditModal
        onConfirm={refetch}
        onClose={() => setIsOpenSendToEdit(false)}
        isOpen={isOpenSendToEdit}
      />
      <DeleteTransactionModal
        refetch={refetch}
        isDeleteModalOpen={isDeleteModalOpen}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
      />
    </>
  );
};
